export const API = {
  // URL: "https://mycaasapi-staging.iamcaas.com/" // STAGING API URL
  URL: "https://api.iamcaas.com/" // PROD API URL
  // URL : "https://mycaasapi-qa.iamcaas.com/" // QA API URL
  // URL : "https://mycaasapi-dev.iamcaas.com/" // DEV API URL
  // URL: "http://mycaasapi-dev.i2itechsolutions.com/"
  // URL: "http://15.184.159.130/"
  // URL: "https://localhost:7292/"
  //URL: "https://mycaasapi-qa.i2itechsolutions.com/"
}